/**
 * Exports for AuditLogViewerAuditorTransactionSidePanel module
 */

export { default as AuditLogViewerAuditorTransactionSidePanel } from './AuditLogViewerAuditorTransactionSidePanel';
export type { AuditLogViewerAuditorTransactionSidePanelProps } from './AuditLogViewerAuditorTransactionSidePanel';
